import $ from 'jquery';
import { atcb_action } from 'add-to-calendar-button';

$('[href*="#calendar"]').on('click', (event) => {
  event.preventDefault();

  if (window.addtocalendar === undefined) {
    return;
  }

  const options = Object.assign(
    {},
    {
      options: [
        'Apple',
        'Google',
        'iCal',
        'Microsoft365',
        'MicrosoftTeams',
        'Outlook.com',
        'Yahoo',
      ],
      trigger: 'click',
    },
    window.addtocalendar
  );

  atcb_action(options);
});
